class FormBlock {
  constructor(block) {
    this.block = block;
    this.selects = block.querySelectorAll(".wpcf7-select");

    this.setupCustomSelects();
    this.events();
  }

  events() {
    document.addEventListener("click", (e) => this.handleClick(e));
  }

  handleClick(e) {
    const closestSelectWrapper = e.target.closest(
      ".wpcf7-form-control-wrap:has(.wpcf7-select)",
    );

    if (closestSelectWrapper) {
      const closestCustomSelect =
        closestSelectWrapper.querySelector(".custom-select");

      this.selects.forEach((select) => {
        const customSelect = select
          .closest(".wpcf7-form-control-wrap")
          ?.querySelector(".custom-select");
        if (customSelect !== closestCustomSelect) {
          customSelect?.classList.remove("custom-select--active");
        }
      });
    } else {
      this.selects.forEach((select) => {
        const customSelect = select
          .closest(".wpcf7-form-control-wrap")
          ?.querySelector(".custom-select");
        customSelect?.classList.remove("custom-select--active");
      });
    }
  }

  setupCustomSelects() {
    this.selects.forEach((select) => {
      const selectWrapper = select.closest(".wpcf7-form-control-wrap");
      const options = select.querySelectorAll("option");

      let html = `
				<div class="custom-select">
					<span class="custom-select__current">${options[0].textContent}</span>
					<ul class="custom-select__options">`;
      options.forEach((option) => {
        html += `
								<li class="custom-select__option" data-value="${option.value}">${option.textContent}</li>
							`;
      });
      html += `</ul>
				</div>
			`;

      selectWrapper.insertAdjacentHTML("beforeend", html);

      const customSelect = selectWrapper.querySelector(".custom-select");
      const customCurrent = selectWrapper.querySelector(
        ".custom-select__current",
      );
      const customOptions = selectWrapper.querySelectorAll(
        ".custom-select__option",
      );

      customSelect.addEventListener("click", () => {
        customSelect.classList.toggle("custom-select--active");
      });

      customOptions.forEach((customOption) => {
        if (customOption.dataset.value) {
          customOption.addEventListener("click", () => {
            select.value = customOption.dataset.value;
            customCurrent.textContent = customOption.textContent;
          });
        }
      });
    });
  }
}

export default FormBlock;
